import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-2 px-5 text-center">
      <h1 className="text-xl font-semibold text-slate-900">{t('common.notFoundTitle')}</h1>
      <p className="text-slate-600">{t('common.notFoundBody')}</p>
    </main>
  );
}
